export const truncateMiddle = (str: string, maxLength = 30) => {
  if (str.length <= maxLength) return str;
  const midLength = Math.floor((maxLength - 3) / 2);
  return `${str.slice(0, midLength)}...${str.slice(-midLength)}`;
};
